/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import './bootstrap';
import './topmenu';

import Swal from 'sweetalert2';

window.Swal = Swal
window.loading_on = function () {
    document.getElementById("loading-overlay").style.display = "block";
};

window.loading_off = function () {
    document.getElementById("loading-overlay").style.display = "none";
};

window.myAlert = function (text) {
    Swal.fire(text)
};

/**
 * Number Formatting Functions using Intl.NumberFormat
 * Global functions for formatting numbers throughout the application
 * Using native JavaScript Intl API for better performance and localization
 */

/**
 * Format number with thousand separators (Thai locale)
 * @param {number|string} number - The number to format
 * @param {number} minimumFractionDigits - Minimum decimal places (default: 2)
 * @param {number} maximumFractionDigits - Maximum decimal places (default: 2)
 * @param {string} locale - Locale string (default: 'th-TH')
 * @returns {string} Formatted number
 *
 * Example: formatNumber(1234.56) -> "1,234.56"
 * Example: formatNumber(1234.5, 0, 0) -> "1,235"
 */
window.formatNumber = function(number, minimumFractionDigits = 2, maximumFractionDigits = 2, locale = 'th-TH') {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return new Intl.NumberFormat(locale, {
            minimumFractionDigits,
            maximumFractionDigits
        }).format(0);
    }

    return new Intl.NumberFormat(locale, {
        minimumFractionDigits,
        maximumFractionDigits
    }).format(num);
};

/**
 * Format number as currency (Thai Baht)
 * @param {number|string} number - The number to format
 * @param {boolean} showSymbol - Show currency symbol (default: true)
 * @param {string} locale - Locale string (default: 'th-TH')
 * @returns {string} Formatted currency
 *
 * Example: formatCurrency(1234.56) -> "฿1,234.56" or "1,234.56 บาท"
 * Example: formatCurrency(1234.56, false) -> "1,234.56"
 */
window.formatCurrency = function(number, showSymbol = true, locale = 'th-TH') {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return showSymbol ? '0.00 บาท' : '0.00';
    }

    if (showSymbol) {
        // Format with custom Thai Baht text
        const formatted = new Intl.NumberFormat(locale, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
        return formatted + ' บาท';
    }

    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};

/**
 * Format number with specific decimal places (no thousands separator)
 * @param {number|string} number - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted decimal
 *
 * Example: formatDecimal(1234.567, 2) -> "1234.57"
 */
window.formatDecimal = function(number, decimals = 2) {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return (0).toFixed(decimals);
    }

    return num.toFixed(decimals);
};

/**
 * Format number as percentage
 * @param {number|string} number - The number to format (e.g., 0.1234 or 12.34)
 * @param {number} decimals - Number of decimal places (default: 2)
 * @param {boolean} isDecimal - If true, number is decimal (0.1234 -> 12.34%)
 * @param {string} locale - Locale string (default: 'th-TH')
 * @returns {string} Formatted percentage
 *
 * Example: formatPercent(12.34) -> "12.34%"
 * Example: formatPercent(0.1234, 2, true) -> "12.34%"
 */
window.formatPercent = function(number, decimals = 2, isDecimal = false, locale = 'th-TH') {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return '0.00%';
    }

    if (isDecimal) {
        // Use Intl for decimal percentage (0.1234 -> 12.34%)
        return new Intl.NumberFormat(locale, {
            style: 'percent',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        }).format(num);
    }

    // For regular numbers, just add %
    return new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(num) + '%';
};

/**
 * Parse formatted number string back to number
 * @param {string|number} formattedNumber - The formatted number string
 * @returns {number} Parsed number
 *
 * Example: parseFormattedNumber("1,234.56") -> 1234.56
 * Example: parseFormattedNumber("1,234.56 บาท") -> 1234.56
 */
window.parseFormattedNumber = function(formattedNumber) {
    if (typeof formattedNumber === 'number') {
        return formattedNumber;
    }

    if (typeof formattedNumber !== 'string') {
        return 0;
    }

    // Remove currency symbols, thousands separators, and non-numeric characters except dot and minus
    const cleaned = formattedNumber
        .replace(/[฿$,\s]/g, '')
        .replace(/บาท/g, '')
        .replace(/[^\d.-]/g, '');

    return parseFloat(cleaned) || 0;
};

/**
 * Format number for display in input fields
 * @param {number|string} number - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} Formatted number for input
 *
 * Example: formatInputNumber(1234.5) -> "1,234.50"
 */
window.formatInputNumber = function(number, decimals = 2) {
    return window.formatNumber(number, decimals, decimals);
};

/**
 * Format large numbers with compact notation
 * @param {number|string} number - The number to format
 * @param {string} locale - Locale string (default: 'th-TH')
 * @returns {string} Formatted abbreviated number
 *
 * Example: formatCompact(1234567) -> "1.2M" (en) or "1.2 ล้าน" (th)
 */
window.formatCompact = function(number, locale = 'en-US') {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return '0';
    }

    // Use compact notation (requires modern browsers)
    if (Intl.NumberFormat.prototype.formatToParts) {
        return new Intl.NumberFormat(locale, {
            notation: 'compact',
            compactDisplay: 'short',
            maximumFractionDigits: 1
        }).format(num);
    }

    // Fallback for older browsers
    const abs = Math.abs(num);
    const sign = num < 0 ? '-' : '';

    if (abs >= 1e9) {
        return sign + (abs / 1e9).toFixed(1) + 'B';
    } else if (abs >= 1e6) {
        return sign + (abs / 1e6).toFixed(1) + 'M';
    } else if (abs >= 1e3) {
        return sign + (abs / 1e3).toFixed(1) + 'K';
    }

    return sign + abs.toFixed(1);
};

/**
 * Format number as Thai currency (alternative with ฿ symbol)
 * @param {number|string} number - The number to format
 * @returns {string} Formatted currency with ฿ symbol
 *
 * Example: formatThaiCurrency(1234.56) -> "฿1,234.56"
 */
window.formatThaiCurrency = function(number) {
    const num = typeof number === 'string' ? parseFloat(number) : number;

    if (isNaN(num) || num === null || num === undefined) {
        return '฿0.00';
    }

    return new Intl.NumberFormat('th-TH', {
        style: 'currency',
        currency: 'THB',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};

// Vue 3 globals (formatXxx + global components) are registered per-app
// inside createPageApp() — see resources/js/app-factory.js. There is no
// longer a global `window.Vue` since each mount creates its own app.

import Alpine from 'alpinejs';
import { navbarSearch } from './components/navbar-search.js';

// Alpine for sprinkles (navbar search, etc.). Vue handles complex pages.
window.Alpine = Alpine;
Alpine.data('navbarSearch', navbarSearch);
Alpine.start();

/**
 * Lazy-loaded page mounts. Each Vue page module ships in its own chunk
 * (Vite splits dynamic imports), so the home page doesn't pay for cart /
 * checkout / product-detail JavaScript it doesn't use.
 *
 * Order matters: checkoutApp must exist before modal-edit's mounted() runs,
 * because modal-edit.saveAddress() references window.checkoutApp. The
 * sequential awaits below preserve that ordering.
 */
async function bootVuePages() {
    if (document.getElementById('checkout-app')) {
        const { mountCheckoutPage } = await import('./pages/checkout-page.js');
        mountCheckoutPage();
    }
    if (document.getElementById('modal-edit-content')) {
        const { mountAddressEditModal } = await import('./components/modals/address-edit-modal.js');
        mountAddressEditModal();
    }
    if (document.getElementById('modal-create-content')) {
        const { mountAddressCreateModal } = await import('./components/modals/address-create-modal.js');
        mountAddressCreateModal();
    }
    if (document.getElementById('modal-tax-edit-content')) {
        const { mountTaxEditModal } = await import('./components/modals/tax-edit-modal.js');
        mountTaxEditModal();
    }
    if (document.getElementById('modal-tax-create-content')) {
        const { mountTaxCreateModal } = await import('./components/modals/tax-create-modal.js');
        mountTaxCreateModal();
    }
    if (document.getElementById('cart')) {
        const { mountCartPage } = await import('./pages/cart-page.js');
        mountCartPage();
    }
    if (document.getElementById('product-detail')) {
        const { mountProductDetailPage } = await import('./pages/product-detail-page.js');
        mountProductDetailPage();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    bootVuePages();
});
